<div class="mx-auto flex min-h-dvh flex-col">
  @if (!hideMenu()) {
    <div class="mx-auto my-4 w-full px-2 xl:w-5xl xl:px-0 2xl:w-4/5">
      <app-navbar></app-navbar>
    </div>
  }
  @if (hideMenu()) {
    <router-outlet />
  } @else {
    <div
      class="mx-auto flex w-full flex-grow flex-col px-2 md:flex-row xl:w-5xl xl:px-0 2xl:w-4/5"
    >
      <app-menu class="mb-4 md:mr-4 md:mb-0 lg:min-w-2xs"></app-menu>
      <div class="mb-4 flex-grow">
        <router-outlet />
      </div>
    </div>
  }

  @if (!hideMenu()) {
    <app-footer></app-footer>
  }

  <app-notifications></app-notifications>
</div>
